import React from 'react';

const Loading = () => {
  return (
    <div className="page">
      <div className="container-xl">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-4">
            <div className="card">
              <div className="card-body text-center">
                <div className="mb-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
                <h3 className="card-title">Loading...</h3>
                <p className="text-muted">
                  Please wait while we check your authentication status.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;